import TopAppBar from '../global/TopBar';
import TaskSideBar from '../global/TaskSideBar';
import { Box } from '@mui/material';

/**
 * The shell for every task screen.
 *
 * height: 100vh on the outer box is what pins the sidebar and the top bar.
 * Without it nothing constrains the layout, the page grows to fit its
 * content, and the WINDOW scrolls - taking the sidebar and top bar out of
 * view with it. The inner overflow:'auto' never engaged, because its parent
 * had no height to overflow. Adminframe has always had this; the task frame
 * was missing it.
 *
 * minHeight: 0 on the column is the flexbox companion to that: a flex child
 * defaults to min-height:auto, which refuses to shrink below its content and
 * would push the scroll back out to the window.
 */
const TaskFrame = ({ children }) => {
  return (
    <Box className="d-flex" sx={{ height: '100vh', overflow: 'hidden' }}>
      <TaskSideBar />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minWidth: 0, // Prevents flex items from overflowing
          minHeight: 0,
        }}
      >
        <TopAppBar />

        {/* The only thing that scrolls. */}
        <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', p: 2 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default TaskFrame;
